import { helper } from '@ember/component/helper';

export const isLast = (params) => params[0] - params[1] === 1;

export default helper(isLast);
